module.exports = __webpack_public_path__ + "img/microsoft-edge.5fcfec2e.svg";